// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__k28Pm","container":"Tooltip_container__VHsv4","arrow":"Tooltip_arrow__hl0m8"};